import { API_URLS } from "../../config/apiUrls";
import axiosInstance from "../../config/axios";

export const getSpecificationTypes = (reqBody) => {
  try {
    const response = axiosInstance.get(API_URLS.specificationTypes, {
      params: reqBody,
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const addSpecificationTypes = (reqBody) => {
  try {
    const response = axiosInstance.post(API_URLS.specificationTypes, reqBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const deleteSpecificationTypes = (reqBody) => {
  try {
    const response = axiosInstance.delete(API_URLS.specificationTypes, {
      data: reqBody,
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const updateSpecificationTypes = (reqBody) => {
  try {
    const response = axiosInstance.put(API_URLS.specificationTypes, reqBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};

export const getCategories = (reqBody) => {
  try {
    const response = axiosInstance.get(API_URLS.category, {
      params: reqBody,
    });
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};
